import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface SpinnerState {
  show: boolean;
  partial: boolean;
}

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private _loading = new BehaviorSubject<SpinnerState>({show: false, partial: false});
  public readonly loading$ = this._loading.asObservable();
  private requestCount = 0;

  show() {
    this.requestCount++;
    this._loading.next({show: true, partial: false});
  }

  hide() {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0;
      this._loading.next({show: false, partial: false});
    }
  }
  reset() {
    this.requestCount = 0;
    this._loading.next({show: false, partial: false});
  }
  showPartialSpinner() {
    this.requestCount++;
    this._loading.next({show: true, partial: true});
  }
}
